/**
 * Toast context and hook. Split from the provider for Fast Refresh.
 */
import { createContext, use } from 'react'

export type ToastTone = 'neutral' | 'success' | 'danger'

export type ToastOptions = {
  title: string
  description?: string | undefined
  tone?: ToastTone | undefined
  /** Milliseconds. `0` keeps it until dismissed — use for anything actionable. */
  duration?: number | undefined
}

export type ToastApi = {
  toast: (options: ToastOptions) => void
}

export const ToastContext = createContext<ToastApi | null>(null)

/**
 * Show a toast.
 *
 * Throws outside a `<Toaster>` rather than no-opping: a save that silently
 * reports nothing is the failure this component exists to prevent, and a
 * missing provider must not be the thing that reintroduces it.
 */
export function useToast(): ToastApi {
  const api = use(ToastContext)
  if (!api) throw new Error('useToast must be used inside a <Toaster>')
  return api
}
